import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  // timeout: 1000,
  headers: {
  }
});

export default (component) => {
	if(component.$root.store.state.currentToken){
		instance.defaults.headers.authorization = 'Bearer ' + component.$root.store.state.currentToken;
	}

	if(component.$root.store.state.currentSystem){
		instance.defaults.headers['X-SC-TYPE'] = component.$root.store.state.currentSystem.type;
		instance.defaults.headers['X-SC-SYSTEM'] = component.$root.store.state.currentSystem.system.id;
	}
	return instance;
}
// instance
